export default __webpack_public_path__ + "static/media/planvirtual.e9ae63ad.png";